var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"title"},[_vm._v("中色云服务")]),_c('div',{staticClass:"info"},[_vm._v("赋能企业以集成化、数字化、智能化手段解决生产控制、生产管理和企业经营的综合问题，打造服务于企业、赋能于工业的智慧大脑")]),_c('div',{staticClass:"btn"})])])
}]

export { render, staticRenderFns }